import {maybeResourceData} from '@freckle/resource-status'
import type {SWRResponse} from 'swr'
import useSWR from 'swr'
import type {RoutesWithQueryParams} from '.'
import {pathData} from '.'
import {useCurrentTeacher} from '../../components/with-resources/utils'
import {getIsBlockedFromFocusMode} from '../../logic/dashboard'
import {fetchIncompleteAssignmentCount} from '../../models/incomplete-assignment-count'

const SWR_FETCH_KEY = 'RouteBlockedDueToFocusMode'

export function useRouteBlockedDueToFocusMode(
  path: keyof RoutesWithQueryParams
): SWRResponse<boolean> {
  const isPathBlockedByFocusMode = pathData[path].isBlockedByFocusMode

  const {currentTeacher} = useCurrentTeacher()
  const inFocusMode = maybeResourceData(currentTeacher)?.focusMode
  const standardSetId = maybeResourceData(currentTeacher)?.mathStandardSetId

  const isBlocked = useSWR(
    inFocusMode === undefined || standardSetId === undefined
      ? null
      : [SWR_FETCH_KEY, inFocusMode, standardSetId, isPathBlockedByFocusMode],
    async ([_key, inFocusMode, standardSetId, isPathBlockedByFocusMode]) =>
      isPathBlockedByFocusMode && inFocusMode
        ? getIsBlockedFromFocusMode(
            (
              await fetchIncompleteAssignmentCount({
                mathStandardSetId: standardSetId,
                unified: 'False'
              })
            ).count,
            inFocusMode
          )
        : false
  )
  return isBlocked
}
